// Mirrors backend App\Services\Geocoding\Enums\GeocodingProviderEnum

export type GeocodingProviderEnum = 'google' | 'mapbox'

export const GeocodingProviderEnum = {
  GOOGLE: 'google',
  MAPBOX: 'mapbox'
} satisfies Record<string, GeocodingProviderEnum>

export const GeocodingProviderEnumValues: readonly GeocodingProviderEnum[] =
  Object.values(GeocodingProviderEnum)
